<template>
    <card class="card-plain">
        <form>
            <h4 class="m-0 pb-2">{{$t('Task')}}</h4>
            <div class="card-body row pt-0">
                <div class="col-12">
                    <div class="row">
                        <div class="col-md-12">
                            <fg-input :label="$t('Title')"
                                      name="title"
                                      autocomplete="off"
                                      v-model="task.title"
                                      :required="validations.title.required"
                                      v-validate="validations.title"
                                      :error="errors.first('title')">
                            </fg-input>
                            <div class="row">
                                <div class="col-md-4 form-group">
                                    <fg-input :label="$t('Due date')"
                                              name="dueDate"
                                              v-model="task.dueDate"
                                              :required="validations.dueDate.required"
                                              v-validate="validations.dueDate"
                                              :error="errors.first('dueDate')">
                                        <el-date-picker v-model="task.dueDate" type="date" placeholder="Pick a date"/>
                                    </fg-input>
                                </div>
                                <div class="col-md-4">
                                    <fg-input :label="$t('Concern')"
                                              name="assigneeType"
                                              autocomplete="off"
                                              v-model="task.assigneeType"
                                              :required="validations.assigneeType.required"
                                              v-validate="validations.assigneeType"
                                              :error="errors.first('assigneeType')">
                                        <el-select size="large"
                                                   class="select-primary"
                                                   :placeholder="$t('Concern')"
                                                   v-model="task.assigneeType">
                                            <el-option v-for="option in ['team', 'user']"
                                                       :value="option"
                                                       :label="$t(option)"
                                                       :key="option">
                                            </el-option>
                                        </el-select>
                                    </fg-input>
                                </div>
                                <div class="col-md-4">
                                    <fg-input v-if="task.assigneeType === 'user'" :label="$t('Concern')"
                                              name="assignee"
                                              required
                                              :value="task.assignee ? task.assignee._id : null"
                                              v-validate="validations.assignee"
                                              :error="errors.first('assignee')"
                                              :task="task">
                                        <task-input-picker v-model="task.assignee" data-type="user" :label="$t('Concern')"/>
                                    </fg-input>
                                    <fg-input v-else-if="task.assigneeType === 'team'" :label="$t('Concern')"
                                              name="assignee"
                                              required
                                              :value="task.assignee ? task.assignee._id : null"
                                              v-validate="validations.assignee"
                                              :error="errors.first('assignee')"
                                              :task="task">
                                        <task-input-picker v-model="task.assignee" data-type="team" :label="$t('Concern')"/>
                                    </fg-input>
                                </div>
                            </div>
                            <fg-input :label="$t('Description')" :required="validations.description.required">
                                <el-input type="textarea"
                                          :autosize="{ minRows: 3, maxRows: 4}"
                                          v-model="task.description"/>
                            </fg-input>
                        </div>
                    </div>
                    <div class="col-lg-12 p-0">
                        <list class="p-0" v-model="task.subtasks" :title="$t('Subtasks')"
                              :columns="columns"
                              :actions="actions.subtasks"
                              :remove="(props) => remove('subtasks', props.$index)"
                              :edit="(props) => edit('subtasks', props.$index)"/>
                    </div>
                </div>
            </div>

            <div class="card-footer text-right actions">
                <p-button round native-type="submit" type="primary" class="btn btn-fill btn-wd btn-one-size-dropdown" :disabled="loading" @click.prevent="save">
                    {{$t('Save')}}
                </p-button>
            </div>

        </form>
        <task-modal :value="task" :show="showDialog" :type="modalType" :index="index" :cancel="cancel"/>
    </card>
</template>

<script>
  import { Select, Option, Input, DatePicker } from 'element-ui'
  import List from '../../Dashboard/Components/BasicList'
  import PButton from '../../UIComponents/Button'
  import {mapActions, mapGetters, mapState} from 'vuex'
  import TaskModal from "./TaskModal";
  import TaskInputPicker from "./TaskInputPicker";

  export default {
    name: 'TaskForm',
    components: {
      TaskModal,
      [Select.name]: Select,
      [Option.name]: Option,
      [Input.name]: Input,
      [DatePicker.name]: DatePicker,
      PButton,
      TaskInputPicker,
      List
    },
    data () {
      return {
        loading: false,
        validations: {
          title: {
            required: true
          },
          dueDate: {
            required: true
          },
          assignee: {
            required: true
          },
          assigneeType: {
            required: true
          },
          description: {
            required: true
          }
        },
        columns: [
          { name: 'title', text: 'Title', sortable: false, align: 'left' },
          { name: 'description', text: 'Description', sortable: false, align: 'left' },
          { name: 'createdAt', text: 'Created at', sortable: false, align: 'left', width: '150px', formatter: this.dateFormatter }
        ],
        actions: {
            subtasks: [{label: 'Add Subtask', click: () => this.openModal('subtasks')}]
        },
        modalType: '',
        index: null,
        assignmentOptions: [
          'admin',
          'manager',
          'user'
        ],
        showDialog: false
      }
    },
    async mounted () {
      await this.init()
    },
    computed: {
      ...mapState('user/tasks', {
          task: state => state.item,
          statusItem: state => state.statusItem
      })
    },
    methods: {
      ...mapActions('user/tasks', ['getTaskDetails', 'updateTask', 'createTask', 'reset']),
      dateFormatter: function (row, column, cellValue) {
          return this.$options.filters.formatDate(cellValue)
      },
      userFormatter: function (row, column, cellValue) {
          return this.$options.filters.formatDisplayName(cellValue)
      },
      async init () {
        this.reset()
        this.task.subtasks = []
        if (this.$route.name === 'TaskEdit') {
          await this.fetch()
        }
      },
      async fetch () {
        if (!this.$route.params.id) {
          return
        }
        try {
          this.loading = true
          this.getTaskDetails({ id: this.$route.params.id })
        } catch (e) { console.log('e', e)} finally {
          this.loading = false
        }
      },
      async save () {
        const isValid = await this.$validator.validateAll()
        if (!isValid) {
          return
        }

        const { title, dueDate, assigneeType, assignee, description, subtasks, trigger, completed, customer, createdBy, createdAt } = this.task
        const data = { title, dueDate, assigneeType, assignee, description, subtasks, trigger, completed, customer, createdBy, createdAt }

        try {
          this.loading = true

          if (this.task._id) {
            await this.updateTask({ id: this.task._id, item: data })
            this.$notify({ message: this.$t('Successfully saved.'), type: 'success' })

          } else {
            const result = await this.createTask({ item: data })
            if (result.data._id) {
              this.$notify({ message: this.$t('Successfully saved.'), type: 'success' })

              this.$router.push({ name: 'TaskEdit', params: { id: result.data._id } })
            }
          }

        } catch (e) {
          console.log(e)
          this.$notify({ message: e.message, type: 'danger' })
        } finally {
          this.loading = false
        }
      },
      openModal: async function (type, index = null) {
          this.showDialog = true
          this.modalType = type
          this.index = index
      },
      cancel: function () {
          this.showDialog = false
      },
      remove: function (type, index) {
          this.task[type].splice(index, 1)
      },
      edit: function (type, index) {
          this.openModal(type, index)
      }
    },

    watch: {
        showDialog (val) {
            if (!val) {
                this.modalType = ''
            }
        }
    }
  }
</script>

<style lang="scss" scoped>
  @media (max-width: 590px) {
      .btn-one-size-dropdown {
          width: 100%;
          padding-left: 0px;
          padding-right: 0px;
          padding-right: 10px !important;
      }
  }

  .card-footer {
    padding-left: 0px;
  }
</style>